import { LOGIN, REFRESH_TOKEN, RESET_TOKEN } from "../actionTypes";

const initialState = {
  accessToken: "",
  refreshToken: "",
};

export const authenReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        accessToken: action.accessToken,
        expiresIn: action.expiresIn,
        refreshExpiresIn: action.refreshExpiresIn,
        refreshToken: action.refreshToken,
        tokenType: action.tokenType,
        sessionState: action.sessionState,
        scope: action.scope,
        customerRefId: action.customerRefId,
        tokenExpire: action.tokenExpire,
        username: action.username,
        password: action.password,
      };

    case REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: action.refreshToken,
      };

    case RESET_TOKEN:
      return {
        accessToken: "",
        refreshToken: "",
      }
    default:
      return state;
  }
};
